module.exports = __webpack_public_path__ + "static/img/lm-intro-h5-1.ec563f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lm-intro-h5-1.png
// module id = LN7a
// module chunks = 0